// extracted by mini-css-extract-plugin
export var collapsedSummary = "_n0-0";